import $ from 'jquery-lib';
window.$ = $;

$.ajaxSetup({
    headers: { ['Newsdesk-Request-Type']: 'ajax' }
});

export default $;
